<template lang="pug">
v-progress-linear(v-if='value', :indeterminate='true')
</template>

<script>
    export default {
        props: {
            value: {
                type: Boolean,
                required: false,
                default: true
            }
        }
    }
</script>
